<template>
  <div class="text-center py-4 d-flex justify-content-center align-items-center">
    <div class="fulfilling-bouncing-circle-spinner">
      <div class="circle"></div>
      <div class="orbit"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Loading-Style",
  }
</script>
  